import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'

import { faUser } from '@fortawesome/pro-light-svg-icons'

import { FaIcon } from '../../../../../App/Components'
import { IAppState } from '../../../../../store/IAppState'
import { AddActivityButton } from '../../../AddActivityButton/AddActivityButton'
import { DisplayActivities } from '../../../DisplayActivities/DisplayActivities'
import { PersonBlock, PersonBlockContent } from '../../../../style'

import { IProps } from './IProps'
import { StyledActivityText } from './style'

export const CustomerAppointment: FunctionComponent<IProps> = ({
  customerIndex,
}) => {
  const { settings, activities } = useSelector((state: IAppState) => ({
    settings: state.settings.values,
    activities: state.appointment.customers[customerIndex]?.activities,
  }))

  // Adding a second service is the salon's choice, whether or not they use menus
  // and whichever view structure they run. It also needs something to add onto:
  // an empty person block means this customer has yet to pick their service.
  const isShowAddExtraActivity: boolean =
    settings.isAddExtraActivityVisible && !!activities?.length

  return (
    <PersonBlock
      data-component="person-block"
      highlightcolor={settings.highlightColor}
    >
      <PersonBlockContent data-component="person-block-content">
        <StyledActivityText data-component="styled-activity-text">
          <FaIcon
            size="lg"
            icon={faUser}
            color={settings.fontColor}
            cssStyle={{ top: '6px', position: 'absolute' }}
          />
          <DisplayActivities
            data-component="display-activities"
            customerIndex={customerIndex}
          />
        </StyledActivityText>
        <AddActivityButton
          data-component="add-activity-button"
          showButton={isShowAddExtraActivity}
          customerIndex={customerIndex}
        />
      </PersonBlockContent>
    </PersonBlock>
  )
}
